import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { Input } from '@bingads-webui-react/primitive-validation';

export class PercentInput extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    reasonId: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
    comment: PropTypes.string,
  };

  static defaultProps = {
    newI18n: {
      getString: _.noop,
    },
    comment: '',
  };

  constructor(props) {
    super(props);
    this.state = { value: '' };
    this.isNewI18n = props.newI18n.getString !== _.noop;
  }

  onValidate = ({ data }) => {
    this.setState({
      value: data.percent,
    });
  };

  handleChange = (e) => {
    this.setState({
      value: e.target.value,
    });
    this.props.callback(e.target.value);
  };

  percentValidator = (percent) => {
    const { i18n, newI18n } = this.props;
    const errorText = this.isNewI18n ? newI18n.getString(_TL_('invalid input')) : i18n.getString('Budget_Landscape_Validator_Invalid_Input');
    const numStr = Number(percent);
    if (!_.isNaN(numStr) && numStr > 0) {
      return [];
    }
    return [errorText];
  };

  render() {
    const {
      reasonId, newI18n, i18n, comment,
    } = this.props;
    const { value } = this.state;

    return (
      <div>
        <div className="input-comment">
          {i18n.getString(comment)}
        </div>
        <div className="input-wrapper">
          <Input
            validationProps={{
              field: 'url',
              validator: this.percentValidator,
              onValidate: this.onValidate,
              i18n,
            }}
            placeholder={this.isNewI18n ? newI18n.getString(_TL_('i.e. 20')) : i18n.getString('Budget_Landscape_Percent_Input_Placeholder')}
            className="percent-input"
            id={`${reasonId}-percent-input`}
            value={value}
            onChange={this.handleChange}
          />
          <span className="percent-suffix">%</span>
        </div>
      </div>
    );
  }
}
